import PargodaLoading from '../../components/PargodaLoading';
import { LoadingPageWrapper } from './LoadingPage.styles';

const LoadingPage = () => {
    return (
        <LoadingPageWrapper>
            <PargodaLoading height={600} width={600} />
        </LoadingPageWrapper>
    );
};

export default LoadingPage;
